import React from 'react'

function Mapa() {

  return (
    <iframe 
      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14722.977759422029!2d-46.7588958!3d-22.7005556!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xf34db079204f9c00!2sM.A.%20Usinagem!5e0!3m2!1sen!2sbr!4v1650140490186!5m2!1sen!2sbr"
      width="400px" 
      height="400px" 
      style={{border:'0'}}
      allowFullScreen="" 
      loading="lazy" 
      referrerPolicy="no-referrer-when-downgrade">
    </iframe>
  )
}

export default React.memo(Mapa)